import Image from 'next/image';
import logoImg from '../../../public/images/logoSICONSPERUTonosdeGris.png';

export default function Logo() {
  return (
    <div className="flex items-center justify-center h-16 w-64"> 
      <Image src={logoImg} alt="Company Logo" className="h-full w-full object-contain" />
    </div>
  )
}